import { render, staticRenderFns } from "./VisitHistory.vue?vue&type=template&id=b621fcee&scoped=true"
import script from "./VisitHistory.vue?vue&type=script&lang=js"
export * from "./VisitHistory.vue?vue&type=script&lang=js"
import style0 from "./VisitHistory.vue?vue&type=style&index=0&id=b621fcee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b621fcee",
  null
  
)

export default component.exports